import React from 'react';
import Auth0 from 'auth0-js';
import config from 'common/config/config';

export const AuthContext = React.createContext({});

export default class Auth {
  auth0 = new Auth0.WebAuth({
    ...config.auth,
    redirectUri: `${window.location.origin}${config.auth.redirectUri}`,
  });

  login = () => {
    this.auth0.authorize();
  };

  getAuthorizeUrl = () => {
    const { clientID, responseType, redirectUri } = this.auth0.baseOptions;

    const options = this.auth0.transactionManager.process({
      clientID,
      responseType,
      redirectUri,
    });

    return this.auth0.client.buildAuthorizeUrl(options);
  };

  handleAuthentication = () => {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          resolve(authResult);
        } else {
          reject(err);
        }
      });
    });
  };

  renewToken = () => {
    return new Promise((resolve, reject) => {
      this.auth0.checkSession({}, (err, authResult) => {
        if (err) {
          reject(err);
        } else {
          resolve(authResult);
        }
      });
    });
  };
}
